import styled from 'styled-components';

const DefaultBox = styled.span`
	color: ${props => props.theme.components.partyJackpotWinCelebrationPopup.colors.amount};
    font-size: 24px;
    margin-top: 5px;
`;

export const PartyJackpotWinCelebrationPopupAmountBox = DefaultBox